import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { connectApi } from "../lib/api";
import { Radio, Users, Circle, Video, Loader2, ArrowLeft } from "lucide-react";

export default function LiveSessions() {
  const navigate = useNavigate();
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try { setSessions(await connectApi.live()); } catch {}
    finally { setLoading(false); }
  };
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, []);

  return (
    <div className="min-h-screen bg-cream pb-16" data-testid="live-sessions">
      <header className="bg-navy sticky top-0 z-20">
        <div className="max-w-4xl mx-auto px-6 h-20 flex items-center justify-between">
          <img src="/logo-supera-light.png" alt="Supera" className="h-11 w-auto object-contain" />
          <button onClick={() => navigate("/mi-cuenta")} className="flex items-center gap-1.5 text-white/70 hover:text-white text-sm font-semibold"><ArrowLeft className="w-4 h-4" /> Mi cuenta</button>
        </div>
      </header>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-2xl bg-[#C0140F] flex items-center justify-center"><Radio className="w-6 h-6 text-white" /></div>
          <div><h1 className="text-2xl font-extrabold text-[#0A1C30]">Sesiones en vivo</h1><p className="text-sm text-[#6B7688]">Únete a las clases y webinars de Supera que están transmitiendo ahora.</p></div>
        </div>
        {loading ? (
          <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-[#6B7688]" /></div>
        ) : sessions.length === 0 ? (
          <div className="text-center py-20 text-[#6B7688]" data-testid="live-empty">
            <Radio className="w-14 h-14 mx-auto mb-4 opacity-30" />
            <p className="font-bold text-lg">No hay sesiones en vivo ahora</p>
            <p className="text-sm">Cuando un instructor inicie una clase en vivo, aparecerá aquí.</p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 gap-4" data-testid="live-list">
            {sessions.map((s) => (
              <button key={s.id} onClick={() => navigate(`/connect/room/${s.id}`)} className="text-left rounded-2xl bg-white border border-black/5 p-5 hover:shadow-md hover:-translate-y-0.5 transition-all" data-testid={`live-enter-${s.id}`}>
                <span className="text-[10px] font-extrabold px-2 py-1 rounded-md tracking-wider bg-[#C0140F] text-white inline-flex items-center gap-1"><Circle className="w-2 h-2 fill-current animate-pulse" /> EN VIVO</span>
                <h3 className="font-extrabold text-[#0A1C30] mt-2">{s.titulo}</h3>
                {s.descripcion && <p className="text-sm text-[#6B7688] mt-0.5 line-clamp-2">{s.descripcion}</p>}
                <div className="flex items-center justify-between mt-3">
                  <span className="text-xs text-[#6B7688] flex items-center gap-1"><Users className="w-3.5 h-3.5" /> {s.online_count || 0} conectados</span>
                  <span className="inline-flex items-center gap-1 text-[#C0140F] font-bold text-sm"><Video className="w-4 h-4" /> Entrar</span>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
